<!-- www.quickepay / 404
Edited with WebStorm
Created by maizerg on 2/20/18 at 5:34 PM
<!-->

<template>
    <div id="404">
        <quick-site-bread-crumb title="Perdido?"/>
        <div class="errorArea secPdng animated">
            <div class="container">
                <div class="row errRow">
                    <div class="col-lg-5 col-lg-offset-1 col-md-6 col-md-offset-1">
                        <div class="errorContent">
                            <div class="h1 errorTitle">404 Error!</div>
                            <span>A página que você está a procura não existe!</span>
                            <!--<form action="#" class="eSearchForm">-->
                                <!--<input type="search" placeholder="Type to search here">-->
                                <!--<input type="submit" value="Search now">-->
                            <!--</form>-->
                            <a href="/"><i class="icofont"></i> Voltar para o inicio</a>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-4 errCol">
                        <div class="eSearchImg">
                            <img src="../assets/images/new_logos/publicfoldersunset.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuickSiteBreadCrumb from '../components/site/SiteBreadCrumb'

export default {components: {QuickSiteBreadCrumb}}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/404.vue